import { Sparkles, Megaphone } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../AuthContext";

/**
 * Ad slot card that shows up between real listings.
 * Signed-in visitors see a "Boost your own listing" CTA;
 * signed-out visitors see a "Create an account to advertise here" CTA.
 */
export const AdSlotCard = ({ variant = "grid" }) => {
  const { user } = useAuth();
  const navigate = useNavigate();

  const isSidebar = variant === "sidebar";

  return (
    <div
      data-testid="ad-slot-card"
      className={`fade-up relative overflow-hidden rounded-md border border-dashed border-foreground/40 bg-gradient-to-br from-secondary to-white flex flex-col ${
        isSidebar ? "p-5" : "p-6"
      }`}
    >
      <div className="flex items-center gap-2 mb-3">
        <div className="inline-flex items-center gap-1.5 rounded-full bg-accent/20 text-accent-foreground/90 px-2 py-1 text-[10px] tracking-[0.2em] uppercase font-bold">
          <Megaphone className="h-3 w-3" strokeWidth={2.5} />
          <span className="text-accent">Ad space</span>
        </div>
      </div>
      <h3 className="font-display text-xl font-bold leading-tight mb-2">
        Your listing could be here.
      </h3>
      <p className="text-sm text-muted-foreground leading-relaxed mb-4">
        Boost any product or buy request so it appears as a <strong>Sponsored</strong> card in every grid across Wholesale &amp; Retail.
      </p>
      <div className="mt-auto">
        <button
          data-testid="ad-slot-cta"
          onClick={() => navigate(user ? "/my-listings" : "/register")}
          className="inline-flex items-center gap-1.5 rounded-full bg-foreground text-background px-4 py-2 text-xs font-semibold hover:bg-primary transition-colors"
        >
          <Sparkles className="h-3 w-3" />
          {user ? "Boost my listing" : "Create an account"}
        </button>
      </div>
      <div className="absolute -bottom-8 -right-8 h-32 w-32 rounded-full bg-accent/10 blur-3xl pointer-events-none" />
    </div>
  );
};

/** Utility: intersperse ad slot cards every N items in a list */
export function injectAdSlots(items, every = 3) {
  const result = [];
  items.forEach((it, i) => {
    result.push({ kind: "item", it, index: i });
    if ((i + 1) % every === 0 && i < items.length - 1) {
      result.push({ kind: "ad", key: `ad-${i}` });
    }
  });
  return result;
}
